'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.dropdown =
  twentyninetimes.dropdown ||
  (function () {
    var dropdownList = document.querySelectorAll('.js-dropdown')

    function init() {
      window.addEventListener('click', () => {
        dropdownList.forEach((dropdown) => {
          dropdown.classList.remove('dropdown--open')
        })
      })

      dropdownList.forEach((dropdown) => {
        dropdown.addEventListener('click', (e) => e.stopPropagation())

        var currentFocus

        const search = dropdown.querySelector('.dropdown__search')
        const itemList = dropdown.querySelector('.dropdown__content-list')
        const dropdownContent = dropdown.querySelector('.dropdown__content')

        const trigger = dropdown.querySelector('.dropdown__trigger')
        const triggerLabel = dropdown.querySelector('.dropdown__trigger-label')
        trigger.addEventListener('click', () => {
          dropdownList.forEach((dropdown) => {
            dropdown.classList.remove('dropdown--open')
          })

          currentFocus = -1
          dropdown.classList.add('dropdown--open')

          if (search) {
            setTimeout(() => {
              search.querySelector('input').focus()
            }, 50)
          }

          var floatingBtns = document.getElementById('phonefloatercontent')
          if (floatingBtns) floatingBtns.classList.add('hide')
        })

        const close = dropdown.querySelector('.dropdown__close')
        close.addEventListener('click', () => {
          dropdown.classList.remove('dropdown--open')

          var floatingBtns = document.getElementById('phonefloatercontent')
          if (floatingBtns) floatingBtns.classList.remove('hide')
        })

        if (itemList) {
          itemList.addEventListener('click', (e) => {
            var target = e.target

            if (!target.classList.contains('dropdown__item')) return

            dropdown.classList.remove('dropdown--open')

            setTimeout(() => {
              var checkedClinic = itemList.querySelector(
                'input[name="clinic_id"]:checked'
              )

              if (checkedClinic) {
                var clinicLabel = checkedClinic.nextElementSibling.innerHTML
                triggerLabel.innerHTML = clinicLabel
              }
            }, 50)
          })
        }

        if (search) {
          const items = dropdown.querySelectorAll('.dropdown__item')
          const titles = dropdown.querySelectorAll('.dropdown__item-title')
          search.addEventListener('input', (e) => {
            currentFocus = -1
            // Include results that start with Aa if letter is Å
            if (e.target.value == 'Å') {
              e.target.value = 'Aa'
            } else if (e.target.value == 'å') {
              e.target.value = 'aa'
            }

            items.forEach((item) => {
              if (
                item.innerText
                  .toLowerCase()
                  .includes(e.target.value.toLowerCase()) ||
                !e.target.value
              ) {
                item.classList.remove('dropdown__item--hidden')
              } else {
                item.classList.add('dropdown__item--hidden')
              }
            })

            titles.forEach((title) => {
              var siblings = []
              var next = title.nextElementSibling
              while (next) {
                if (next.matches('.dropdown__item-title')) break

                if (next.tagName != 'INPUT') siblings.push(next)

                next = next.nextElementSibling
              }

              if (
                siblings.some(
                  (sibling) =>
                    !sibling.classList.contains('dropdown__item--hidden')
                )
              ) {
                title.classList.remove('dropdown__item-title--hidden')
              } else {
                title.classList.add('dropdown__item-title--hidden')
              }
            })
          })
        }

        /*execute a function presses a key on the keyboard:*/
        search.addEventListener('keydown', function (e) {
          var x = itemList

          if (x)
            x = x.querySelectorAll(
              '.dropdown__item:not(.dropdown__item--hidden)'
            )

          if (!x) return

          if (e.keyCode == 40) {
            e.preventDefault() // Prevent cursor from moving around in input field
            /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
            e.preventDefault()
            currentFocus++
            /*and and make the current item more visible:*/
            addActive(x)
          } else if (e.keyCode == 38) {
            e.preventDefault() // Prevent cursor from moving around in input field
            /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
            if (currentFocus == 0) {
              /* If already is first option, remove active state, focus input and set value to start value */
              currentFocus = -1
              removeActive(x)
              search
                .querySelector('input')
                .removeAttribute('aria-activedescendant')
            } else {
              currentFocus--

              /*and and make the current item more visible:*/
              addActive(x)
            }
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault()
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) x[currentFocus].click()
            } else {
              if (x.length == 1) {
                x[0].click()
              } else if (x.length > 1) {
                currentFocus = 0
                addActive(x)
              } else {
                // DO NOTHING
              }
            }
          } else if (e.keyCode == 27) {
            /*If the ESC key is pressed, execute a function;*/
            e.preventDefault()
            closeAllLists(x)
          }
        })

        function scrollToElementD(x) {
          var topPos = x.offsetTop + 10,
            elm_outer = dropdownContent.clientHeight / 2
          dropdownContent.scrollTop = topPos - elm_outer
        }

        function addActive(x) {
          /*a function to classify an item as "active":*/
          if (!x) return false
          /*start by removing the "active" class on all items:*/
          removeActive(x)
          if (currentFocus >= x.length) currentFocus = 0
          if (currentFocus < 0) currentFocus = x.length - 1
          /*add class "autocomplete-active":*/
          x[currentFocus].classList.add('active')
          var current_id = x[currentFocus].getAttribute('id')
          search
            .querySelector('input')
            .setAttribute('aria-activedescendant', current_id)
          scrollToElementD(x[currentFocus])
        }
        function removeActive(x) {
          /*a function to remove the "active" class from all autocomplete items:*/
          for (var i = 0; i < x.length; i++) {
            x[i].classList.remove('active')
          }
        }

        function closeAllLists(x) {
          /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
          dropdown.classList.remove('dropdown--open')
          search.querySelector('input').removeAttribute('aria-activedescendant')

          setTimeout(() => {
            dropdownContent.scrollTop = 0
          }, 300)

          x = itemList.querySelectorAll('.dropdown__item')
          removeActive(x)
        }
      })

      var priceCalculator = document.getElementById('price-calculator')
      if (priceCalculator) {
        const radios = priceCalculator.querySelectorAll('input[type="radio"]')
        const price_section = document.getElementById('price-section')
        const price_table = document.getElementById('price-table')

        priceCalculator.addEventListener('submit', (e) => {
          e.preventDefault()

          var radio_clinic = document.querySelector(
            'input[name="clinic_id"]:checked'
          )

          if (!radio_clinic) {
            priceCalculator.classList.add('clinic-missing')

            return
          }

          var scrollTop = Math.max(
              window.pageYOffset,
              document.documentElement.scrollTop,
              document.body.scrollTop
            ),
            header_height = window.innerWidth > 991 ? 130 : 90,
            elmnt_scrollTop =
              scrollTop +
              price_section.getBoundingClientRect().top -
              header_height

          scrollTo(elmnt_scrollTop, 500)
        })

        radios.forEach((radio) => {
          if (radio.checked == true) {
            setTimeout(() => {
              setActiveLabel(radio)
            }, 100)
          }
          radio.addEventListener('change', () => {
            const conditionFields = document.querySelectorAll(
              '[data-conditional-insurance]'
            )
            const prices = document.querySelectorAll('[data-price]')
            const disclaimers = document.querySelectorAll('[data-disclaimer]')

            var radio_value = radio.value,
              radio_name = radio.name

            setCookie('client_' + radio_name, radio_value, 0)
            setUrlParams(radio_name, radio_value)

            if (radio_name != 'clinic_id') {
              setActiveLabel(radio)
            }

            if (radio_name == 'group' || radio_name == 'student') {
              var radio_student = document.querySelector(
                  'input[name="student"]:checked'
                ).value,
                radio_group = document.querySelector(
                  'input[name="group"]:checked'
                ).value

              var attribute = 'data-price-group-' + radio_value,
                disclaimerAttribute = 'data-disclaimer-group-' + radio_value
              if (radio_name == 'student' && radio_value == 0) {
                radio_value = radio_group

                attribute = 'data-price-group-' + radio_value
                disclaimerAttribute = 'data-disclaimer-group-' + radio_value
              }
              if (radio_student == 1) {
                radio_value = radio_group

                attribute = 'data-price-group-' + radio_value + '-student'
                disclaimerAttribute =
                  'data-disclaimer-group-' + radio_value + '-student'
              }

              prices.forEach((price) => {
                var priceNew = price.getAttribute(attribute)

                if (!priceNew) return

                price.innerHTML = priceNew
              })

              if (disclaimers) {
                disclaimers.forEach((disclaimer) => {
                  var disclaimerNew =
                    disclaimer.hasAttribute(disclaimerAttribute)

                  disclaimerNew == true
                    ? disclaimer.classList.add('active')
                    : disclaimer.classList.remove('active')
                })
              }
            }

            if (radio_name == 'clinic_id') {
              priceCalculator.classList.remove('clinic-missing')

              getClinicPrices()
            }

            if (radio_name == 'insurance') {
              if (radio_value == 0) {
                priceCalculator.classList.add('insurance-off')
                price_table.classList.add('insurance-off')

                if (conditionFields) {
                  conditionFields.forEach((field) => {
                    if (field.classList.contains('price-calculator__field')) {
                      field.classList.add('price-calculator__field--hidden')
                    } else {
                      field.classList.add('hidden')
                    }

                    var inputs = field.querySelectorAll('input')
                    if (inputs) {
                      inputs.forEach((input) => {
                        input.setAttribute('disabled', '')
                      })
                    }
                  })
                }
              } else {
                priceCalculator.classList.remove('insurance-off')
                price_table.classList.remove('insurance-off')

                if (conditionFields) {
                  conditionFields.forEach((field) => {
                    if (field.classList.contains('price-calculator__field')) {
                      field.classList.remove('price-calculator__field--hidden')
                    } else {
                      field.classList.remove('hidden')
                    }

                    var inputs = field.querySelectorAll('input')
                    if (inputs) {
                      inputs.forEach((input) => {
                        input.removeAttribute('disabled', '')
                      })
                    }
                  })
                }

                var checkedRadios = priceCalculator.querySelectorAll(
                  'input[type="radio"]:checked'
                )
                setTimeout(() => {
                  checkedRadios.forEach((checkedRadio) => {
                    setActiveLabel(checkedRadio)
                  })
                }, 500)
              }
            }
          })
        })
      }

      function setUrlParams(name, value) {
        // Construct URLSearchParams object instance from current URL querystring.
        var queryParams = new URLSearchParams(window.location.search)

        // Set new or modify existing parameter value.
        queryParams.set(name, value)

        // Replace current querystring with the new one.
        history.replaceState(null, null, '?' + queryParams.toString())
      }

      function setActiveLabel(radio) {
        var radioGroup = radio.closest('.radio-group')

        if (!radioGroup) return

        var active_label = radioGroup.querySelector('.radio-group__indicator'),
          label = radio.nextElementSibling

        var parentPos = radioGroup.getBoundingClientRect(),
          labelPos = label.getBoundingClientRect(),
          labelWidth = label.offsetWidth,
          posLeft = labelPos.left - parentPos.left

        active_label.style.transform = `translate3d(${posLeft}px, 0, 0)`
        active_label.style.width = `${labelWidth}px`
      }

      function getClinicPrices() {
        // https://getbutterfly.com/how-to-replace-jquery-ajax-with-vanilla-javascript-in-wordpress/
        var xhr = new XMLHttpRequest(),
          method = 'POST',
          url = load_more_params.ajaxurl,
          action = 'get_clinic_prices',
          price_section = document.getElementById('price-section'),
          section__inner = price_section.querySelector('.price-section__inner')

        xhr.open(method, url, true)
        //xhr.setRequestHeader('X-WP-Nonce', my_restapi_details.nonce);
        xhr.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded;'
        )
        xhr.send('action=' + action)

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) {
            // If successful

            var clinic_prices = xhr.response

            price_section.classList.add('price-section--hidden')
            setTimeout(() => {
              section__inner.innerHTML = clinic_prices

              price_section.classList.remove('price-section--hidden')
            }, 300)
          } else {
            // If fail
            alert('Something went wrong... Please try again later')
          }
        }

        xhr.onerror = function () {
          alert('Something went wrong... Please try again later')
        }
      }
    }

    return {
      init,
    }
  })()

function setCookie(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expireDays=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookie(cname) {
  var name = cname + '=',
    decodedCookie = decodeURIComponent(document.cookie),
    ca = decodedCookie.split(';')

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

var scrollTo = function (to, duration) {
  var element = document.scrollingElement || document.documentElement,
    start = element.scrollTop,
    change = to - start,
    startDate = +new Date(),
    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    easeInOutQuad = function (t, b, c, d) {
      t /= d / 2
      if (t < 1) return (c / 2) * t * t + b
      t--
      return (-c / 2) * (t * (t - 2) - 1) + b
    },
    animateScroll = function () {
      var currentDate = +new Date()
      var currentTime = currentDate - startDate
      element.scrollTop = parseInt(
        easeInOutQuad(currentTime, start, change, duration)
      )
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll)
      } else {
        element.scrollTop = to
      }
    }

  animateScroll()
}
